export const featureTypeToCollection = {
  challenge: "profiles",
  team: "userTeamJunction",
  gather: "userGatherJunction",
  news: "news",
};
